module.exports = Framework7;


//////////////////
// WEBPACK FOOTER
// external "Framework7"
// module id = sMfh
// module chunks = 252